<template>
  <div>
    <div
      class="shopping-cart-item-modifiers-line"
      :class="{
        'shopping-cart-item-modifiers-line__modal': type == 'modal'
      }"
    >
      <div
        :class="{
          'shopping-cart-item-modifiers-line__title': type != 'modal',
          'shopping-cart-item-modifiers-line__title-modal': type == 'modal'
        }"
        :style="{ paddingLeft: 15 * (level - 1) + 'px' }"
      >
        {{ name }}
      </div>
      <div class="shopping-cart-item-modifiers-line__cost">
        {{ cost > 0 ? `+$${cost}` : "" }}
      </div>
    </div>
    <div v-if="nodes?.length > 0">
      <cart-list-item-modifiers-line
        v-for="node in formatter(nodes)"
        :key="node.name"
        :name="node.name"
        :cost="node.cost"
        :nodes="node.nodes"
        :level="level + 1"
        :formatter="formatter"
        :type="type"
      ></cart-list-item-modifiers-line>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartListItemModifiersLine",
  props: {
    name: String,
    cost: Number,
    nodes: Array,
    level: Number,
    formatter: Function,
    type: String
  }
};
</script>

<style scoped lang="scss">
.shopping-cart-item-modifiers-line {
  display: flex;
  margin-left: 24px;
  justify-content: space-between;
  color: var(--group-3-color-3);
  font-weight: normal;
  margin-bottom: 10px;

  &__modal {
    font-size: 14px;
    margin-right: 14px;
    color: var(--group-3-color-2);
  }

  &__title {
    margin-left: 40px;
    @include respond-to-mobile {
      margin-left: 30px;
    }
  }

  &__title-modal {
    font-size: 14px;
    margin-left: 5px;
    @include respond-to-mobile {
      margin-left: 5px;
    }
  }
}
</style>
